import React from 'react';
import { ProgressSpinner } from '@everfi/reactifi';

const Fallback = ({ children }) => (
  <>
    <div>
      <header id="header"></header>
    </div>
    <nav id="sidebar" className="nav sidebar"></nav>
    <main id="main" className="p2">
      <div id="content" className="fallback-content">
        {children || <ProgressSpinner pageLoader={true} />}
      </div>
    </main>
  </>
);

export default Fallback;
